__turbopack_context__.v({
  "backgroundImage": "BackgroundIllustration-module-scss-module__vnS9Iq__backgroundImage",
  "desktopImage": "BackgroundIllustration-module-scss-module__vnS9Iq__desktopImage",
  "gradientOverlay": "BackgroundIllustration-module-scss-module__vnS9Iq__gradientOverlay",
  "mobileImage": "BackgroundIllustration-module-scss-module__vnS9Iq__mobileImage",
});
